


































































































/* General */
import Vue from 'vue'
import ClipboardJS from 'clipboard'

/* Mixins */

/* Components */
import ToEmailInput from './to-email-input.vue'
import CustomerPickerDisplay from './customer-picker-display.vue'

/* Helpers */
import TextAssistant from '@/helpers/text-assistant'
import ColorAssistant from '@/helpers/color-assistant'

/* Data types */

/* API */
import {
  ILinkedItemForListing,
  IPersonWithEmail,
} from '@/api/types/response.types'

export default Vue.extend({
  name: 'CustomerPicker',

  components: {
    ToEmailInput,
    CustomerPickerDisplay,
  },

  props: {
    mailboxId: {
      type: Number,
      required: true,
    },
    customer: {
      type: Object as () => IPersonWithEmail,
      required: true,
    },
    otherConversations: {
      type: Array as () => ILinkedItemForListing[],
      required: true,
    },
  },

  data() {
    return {
      ColorAssistant,
      newName: '',
      isUpdatingCustomerName: false,

      newEmail: '',
      isChangingCustomer: false,
      enableChangeCustomerSubmit: false,

      showDropdown: false,
      emailClipboard: null,
      emailClipboardClass: 'copy-email-to-clipboard',
    }
  },

  computed: {
    enableChangeCustomerNameSubmit(): boolean {
      return (
        this.newName !== '' &&
        !this.isNewNameActuallyAnEmail &&
        this.customer.name !== this.newName
      )
    },
    isNewNameActuallyAnEmail(): boolean {
      return TextAssistant.isValidEmail(this.newName)
    },
    hasOtherConversations(): boolean {
      return this.otherConversations.length > 0
    },
    otherConversationsLabel(): string {
      const convoCount = this.otherConversations.length
      if (convoCount === 1) {
        return '<strong>View</strong> 1 other conversation'
      }
      return `<strong>View</strong> ${convoCount} other conversations`
    },
  },
  watch: {
    customer: {
      immediate: true,
      handler(newVal: IPersonWithEmail) {
        this.resetNewName()
      },
    },
  },
  mounted() {
    this.emailClipboard = new ClipboardJS('.' + this.emailClipboardClass)
    this.emailClipboard.on('success', (e: any) => {
      // @ts-ignore
      this.$messaging.showSuccess('Copied email address to your clipboard!')
      e.clearSelection()
    })
  },

  beforeDestroy() {
    this.emailClipboard.destroy()
  },

  methods: {
    closeDropdown() {
      this.showDropdown = true
      this.$nextTick(() => {
        this.showDropdown = false
      })
    },
    resetNewName() {
      // If name is already an email (via server-side defaults), leave it blank.
      // This prevents "woops" alert from firing.
      this.newName = ''
      if (!TextAssistant.isValidEmail(this.customer.name)) {
        this.newName = this.customer.name
      }
    },

    handleCancelCustomerUpdate() {
      this.isChangingCustomer = false
      this.newEmail = ''
    },

    handleCancelCustomerNameUpdate() {
      this.isUpdatingCustomerName = false
      this.resetNewName()
    },

    updateCustomerName() {
      if (this.customer.name !== this.newName) {
        this.$emit('customer-name-updated', this.newName)
      }
      this.isUpdatingCustomerName = false
    },

    updateCustomer() {
      if (this.customer.email !== this.newEmail) {
        this.$emit('customer-updated', this.newEmail)
      }
      this.isChangingCustomer = false
    },

    async handleUpdateCustomerNameClick() {
      this.isUpdatingCustomerName = true
      await this.$nextTick()
      // @ts-ignore
      this.$refs.nameInput.focus()
    },

    handleUpdateCustomerViaWoopsMessaging() {
      this.newEmail = this.newName
      this.updateCustomer()
      this.isUpdatingCustomerName = false
      this.newName = this.customer.name
    },

    async handleChangeCustomerClick() {
      this.isChangingCustomer = true
      this.newEmail = ''
      await this.$nextTick()
    },

    async handleOtherConversationsClick() {
      this.closeDropdown()
      this.$emit('other-conversations-clicked')
    },
  },
})
